<form #createConsultaForm="ngForm">
    <app-custom-modal #modal [title]="'Adicionar Consulta'" [subtitle]="''" (onCloseClick)="modal.close()"
        (onSaveClick)="save()" [saveLabel]="'Adicionar →'" [saveDisabled]="agendas.length == 0 || createConsultaForm.invalid || saving">
        <div class="container">
            <div class="mb-4 text-center text-danger" *ngIf="agendas.length == 0 && consulta.profissionalId">
                <button class="btn text-danger" (click)="criarAgenda()">Por favor crie uma agenda e defina os horários disponíveis para poder marcar consultas!</button>
            </div>
            <div class="mb-4">
                <label for="descricao" class="form-label required">Descrição</label>
                <input type="text" class="form-control" name="descricao" maxlength="32" [(ngModel)]="consulta.descricao"
                    #descricaoModel="ngModel" #descricaoEl id="descricao" required placeholder="Digite aqui" />
                <abp-validation-summary [control]="descricaoModel" [controlEl]="descricaoEl"></abp-validation-summary>
            </div>
            <div class="mb-4">
                <label for="observacao" class="form-label">Observações</label>
                <input type="text" class="form-control" name="observacao" [(ngModel)]="consulta.observacoes"
                    #observacaoModel="ngModel" #observacaoEl id="observacao" placeholder="Digite aqui" />
                <abp-validation-summary [control]="observacaoModel" [controlEl]="observacaoEl"></abp-validation-summary>
            </div>
            <div class="mb-4">
                <div class="d-flex row justify-content-between align-items-center">
                    <div class="col-6 d-flex justify-content-start">
                        <label for="descricao" class="form-label required">Paciente</label>
                    </div>
                    <div class="col-6 d-flex justify-content-end">
                        <button class="btn btn-novo-paciente" (click)="changeNovoPaciente()">
                            <span>{{!cadastrarNovoPaciente ? 'Novo Paciente' : 'Selecionar paciente'}}</span>
                            <i class="hgi hgi-stroke hgi-plus-sign-circle ml-1"></i>
                        </button>
                    </div>
                </div>
                <div *ngIf="!cadastrarNovoPaciente">
                    <div class="input-group mb-4">
                        <img class="input-group-text" src="../../../../assets/img/icons/search.svg" alt="Busca">
                        <input type="text" id="txtSearchName" class="busca-input" placeholder="Pesquisar por nome"
                            (input)="atualizarListaPacientes($event)">
                    </div>
                    <ng-container *ngIf="!consulta.pacienteId">
                        <div *ngIf="pacientesFiltrados.length > 0" class="card mt-4 scroll-container">
                            <div *ngFor="let paciente of pacientesFiltrados" (click)="selecionarPaciente(paciente)"
                                class="row d-flex align-items-center paciente-container">
                                <div class="col-auto">
                                    <div class="user-foto-container">
                                        <img src="../../../../assets/img/user.png" alt="Foto do usuário">
                                    </div>
                                </div>
                                <div class="col-auto d-flex flex-column justify-content-start p-0">
                                    <p class="nome-paciente">{{paciente.nome}}</p>
                                    <p class="cpf-paciente">{{paciente.cpf | cpfCnpj}}</p>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="pacientesSelecionado && consulta.pacienteId">
                        <div class="card mt-4 scroll-container">
                            <div class="row d-flex align-items-center">
                                <div class="col-auto">
                                    <div class="user-foto-container">
                                        <img src="../../../../assets/img/user.png" alt="Foto do usuário">
                                    </div>
                                </div>
                                <div class="col-auto d-flex flex-column justify-content-start p-0">
                                    <p class="nome-paciente">{{pacientesSelecionado.nome}}</p>
                                    <p class="cpf-paciente">{{pacientesSelecionado.cpf | cpfCnpj}}</p>
                                </div>
                                <div class="col d-flex align-items-center justify-content-end">
                                    <button class="btn icon icon-danger" title="Remover da consulta"
                                        (click)="selecionarPaciente()">
                                        <i class="hgi hgi-stroke hgi-delete-02"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <div *ngIf="cadastrarNovoPaciente">
                    <div class="mb-4">
                        <label for="nome" class="form-label required">Nome</label>
                        <input type="text" class="form-control" name="nome" maxlength="32"
                            [(ngModel)]="consulta.novoPaciente.nome" #nomeModel="ngModel" #nomeEl id="nome" required
                            placeholder="Digite aqui" />
                        <abp-validation-summary [control]="nomeModel" [controlEl]="nomeEl"></abp-validation-summary>
                    </div>
                    <div class="mb-4">
                        <label for="cpf" class="form-label required">CPF</label>
                        <input type="text" class="form-control" name="cpf" mask="000.000.000-00"
                            [(ngModel)]="consulta.novoPaciente.cpf" #cpfModel="ngModel" #cpfEl id="cpf" required
                            placeholder="Digite aqui" />
                        <abp-validation-summary [control]="cpfModel" [controlEl]="cpfEl"></abp-validation-summary>
                    </div>
                    <div class="mb-4">
                        <label for="email" class="form-label">E-mail</label>
                        <input type="email" class="form-control" name="email" [(ngModel)]="consulta.novoPaciente.email"
                            #emailModel="ngModel" #emailEl id="email" placeholder="Digite aqui" />
                        <abp-validation-summary [control]="emailModel" [controlEl]="emailEl"></abp-validation-summary>
                    </div>
                    <div class="mb-4">
                        <label for="celular" class="form-label">Celular</label>
                        <input type="text" class="form-control" name="celular" mask="(00) 00000-0000"
                            [(ngModel)]="consulta.novoPaciente.celular" #celularModel="ngModel" #celularEl id="celular"
                            placeholder="Digite aqui" />
                        <abp-validation-summary [control]="celularModel"
                            [controlEl]="celularEl"></abp-validation-summary>
                    </div>
                </div>
            </div>
            <div class="mb-4">
                <label for="descricao" class="form-label required">Profissional da Saúde</label>
                <div *ngIf="profissionais.length > 1" class=" input-group mb-4">
                    <img class="input-group-text" src="../../../../assets/img/icons/search.svg" alt="Busca">
                    <input type="text" id="txtSearchProfissional" class="busca-input" placeholder="Pesquisar por nome"
                        (input)="atualizarListaProfissionais($event)">
                </div>
                <ng-container *ngIf="!consulta.profissionalId">
                    <div *ngIf="profissionaisFiltrados.length > 0" class="card mt-4 scroll-container">
                        <div *ngFor="let profissional of profissionaisFiltrados"
                            (click)="selecionarProfisional(profissional)"
                            class="row d-flex align-items-center paciente-container">
                            <div class="col-auto">
                                <div class="user-foto-container">
                                    <img src="../../../../assets/img/user.png" alt="Foto do usuário">
                                </div>
                            </div>
                            <div class="col-auto d-flex flex-column justify-content-start p-0">
                                <p class="nome-paciente">{{profissional.nome}}</p>
                                <p class="cpf-paciente">{{profissional.cpf | cpfCnpj}}</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="profisionalSelecionado && consulta.profissionalId">
                    <div class="card mt-4 scroll-container">
                        <div class="row d-flex align-items-center">
                            <div class="col-auto">
                                <div class="user-foto-container">
                                    <img src="../../../../assets/img/user.png" alt="Foto do usuário">
                                </div>
                            </div>
                            <div class="col-auto d-flex flex-column justify-content-start p-0">
                                <p class="nome-paciente">{{profisionalSelecionado.nome}}</p>
                                <p class="cpf-paciente">{{profisionalSelecionado.cpf | cpfCnpj}}</p>
                            </div>
                            <div *ngIf="profissionais.length > 1"
                                class="col d-flex align-items-center justify-content-end">
                                <button class="btn icon icon-danger" title="Remover da consulta"
                                    (click)="selecionarProfisional()">
                                    <i class="hgi hgi-stroke hgi-delete-02"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div class="mb-4">
                    <label for="convenio-selected" class="form-label required">Convênio</label>
                    <select name="convenio-selected" id="convenio-selected" class="custom-select form-control"
                        [(ngModel)]="consulta.convenioId">
                        <option [value]="null">Particular</option>
                        <option *ngFor="let convenio of convenios" [value]="convenio.id">{{convenio.razaoSocial}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="mb-4">
                <label for="tipoConsulta" class="form-label required">Tipo de consulta</label>
                <select name="tipoConsulta" class="form-control" id="tipoConsulta" required
                    [(ngModel)]="consulta.tipoConsulta">
                    <option *ngFor="let tipo of tipoConsulta.tipoConsulta" [value]="tipo.type">{{tipo.name}}</option>
                </select>
            </div>
            <div class="mb-4">
                <label for="sala" class="form-label required">Sala</label>
                <select name="sala" class="form-control" id="sala" [disabled]="agendas.length == 0"
                    [(ngModel)]="consulta.agendaId" (change)="selecionarAgenda()" required>
                    <option *ngFor="let agenda of agendas" [ngValue]="agenda.id">
                        {{ agenda.nomeSala }}
                    </option>
                </select>
            </div>
            <div class="mb-4">
                <div class="input-group d-flex flex-column">
                    <label for="dataConsulta" class="form-label required">Data da consulta</label>
                    <custom-datepicker-selected #datePicker [isDisabled]="!consulta.agendaId"
                        (onSelected)="setDataConsulta($event)" [dataSelecionada]="consulta.dataConsulta"
                        (onAlterMonth)="atualizarDatasDisponiveis($event)"></custom-datepicker-selected>
                </div>
            </div>
            <div class="mb-4">
                <label for="horarioConsulta" class="form-label required">Horário</label>
                <select name="horarioConsulta" class="form-control" id="horarioConsulta"
                    [(ngModel)]="horarioSelecionado" (change)="setHorario()" required [disabled]="!dataConsulta">
                    <option *ngFor="let horario of horariosDisponiveis" [ngValue]="horario">
                        {{ horario.horaInicio }}
                    </option>
                </select>
            </div>
            <div class="mb-4">
                <visualizar-anexos-consulta [anexos]="consulta.anexos" [pacienteId]="pacientesSelecionado?.id"
                    [tipoUsuario]="tipoUsuario" (onFileInsert)="updateFileList($event)"
                    (onFileRemove)="updateFileList($event)"></visualizar-anexos-consulta>
            </div>
        </div>
    </app-custom-modal>
</form>